<div *ngIf="shouldDisplayBanner" class="rs-padding-bottom2 rs-maxh">
  <div class="panel rs-no-margin rs-bg-black rs-maxh rs-flex rs-flex-dir-col">
    <div class="rs-flex-row rs-flex-collapse rs-flex-middle rs-justify-center-small-only">
      <div class="rs-flex-columns">
        <h3 class="rs-tit6 rs-txt-c2 small-only-text-center">{{ packName }}</h3>
      </div>
      <div class="rs-flex-columns">
        <img
          alt="Netflix"
          class="rs-maxh-s3 rs-margin-bottom1 rs-margin-left1"
          [src]="'tv.netflixBS.banner.netflix.image.link' | translate"
        />
      </div>
    </div>
    <p class="rs-txt-c2 rs-font-pxB">
      {{ 'tv.netflixBS.banner.description' | translate }}
    </p>
    <div class="rs-flex-grow rs-flex rs-flex-bottom" data-cy="tvNetflixBannerButton">
      <div class="rs-maxw">
        <a
          href="javascript:void(0)"
          [routerLink]="[
            '/details/option',
            netflixBuyAndSell?.optionCodeForDescription,
            productType
          ]"
          [queryParams]="isUnmigratedTvCustomer ? { old: true } : null"
          (click)="savePii(product?.accessNumber)"
          class="rs-btn rs-btn-neg"
          data-tms-event="button-click"
          data-tms-button-zone="netflix"
          data-tms-button-name="see more"
          >{{
            isBuyAndSellActive
              ? ('tv.netflixBS.banner.active' | translate)
              : ('tv.netflixBS.banner.available' | translate)
          }}<span class="show-for-sr">{{
            isBuyAndSellActive
              ? ('tv.netflixBS.banner.active' | translate)
              : ('tv.netflixBS.banner.available' | translate)
          }}</span></a
        >
      </div>
    </div>
  </div>
</div>
